<div class="medical-record-close-form-wrapper">
  <!-- form -->
  <form [formGroup]="form" class="medical-record-close-form" *ngIf="form">
    <!-- closing date -->
    <app-form-input-date [field]="'closingDate'" [formControl]="f['closingDate']" formControlName="closingDate"
      [minDate]="today"></app-form-input-date>
    <!-- closing report -->
    <app-form-input-editor [field]="'closingReport'" [formControl]="f['closingReport']"
      [formControlName]="'closingReport'" [height]="'15vh'"></app-form-input-editor>
  </form>
  <!-- buttons -->
  <div class="buttons">
    <p-button [label]="'button.cancel' | translate" severity="secondary" (click)="cancel()"/>
    <p-button [label]="'button.save' | translate" severity="contrast" (click)="save()"/>
  </div>
</div>
    